module.exports = {
    API_KEY : "d42a0d190464a2be90977c3996382811",
    TZ : "Asia/Bahrain",
    
    // API_ADMIN_URL : "http://localhost:61100/v1/admin/",
    // API_BASE_URL : "http://localhost:61100/",
    // ASSETS_BASE_URL : "http://localhost:61100/",
    // CRMA_ASSETS_BASE_URL : "http://localhost:61100/",

    // API_ADMIN_URL : "https://staging.everydaydiscountcentre.com/v1/admin/",
    // API_BASE_URL : "https://staging.everydaydiscountcentre.com/",
    // ASSETS_BASE_URL : "https://bucketeday.2026evdpos.com/",
    // CRMA_ASSETS_BASE_URL : "https://bucketeday.2026evdpos.com/",

    API_ADMIN_URL : "https://crown-king.com/v1/admin/",
    API_BASE_URL : "https://crown-king.com/",
    ASSETS_BASE_URL : "https://bucketeday.2026evdpos.com/",
    CRMA_ASSETS_BASE_URL : "https://bucketeday.2026evdpos.com/",
    
    ANALYSER_URL : "https://analyser.crown-king.com/",

}